import {
  useProviderRiskSnapshot,
  useRefetchProviderRiskOnRecalculation,
} from '@app/src/pages/TopicalRisk/CompanyPage/useProviderRiskSnapshot'
import type { Provider } from '@app/src/types/organizations'
import { Stack, useTheme } from '@mui/material'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import * as React from 'react'
import { AutomatedRiskSection } from './AutomatedRiskSection'
import { RiskOverTimeSection } from './RiskOverTimeSection'

type TopicalRiskCompanyPageSceneProps = {
  provider: Provider
}

const breakpointsOffset = 100

const TopicalRiskCompanyPageScene = ({ provider }: TopicalRiskCompanyPageSceneProps) => {
  const parentTheme = useTheme()

  //  Create a custom theme with breakpoints offset to compensate for the left side panel width
  const customBreakpointsTheme = React.useMemo(
    () =>
      createTheme({
        ...parentTheme,
        breakpoints: {
          values: {
            xs: 0,
            sm: Math.max(0, (parentTheme.breakpoints.values.sm || 600) + breakpointsOffset + 300),
            md: Math.max(0, (parentTheme.breakpoints.values.md || 900) + breakpointsOffset),
            lg: Math.max(0, (parentTheme.breakpoints.values.lg || 1200) + breakpointsOffset),
            xl: Math.max(0, (parentTheme.breakpoints.values.xl || 1536) + breakpointsOffset),
          },
        },
      }),
    [parentTheme],
  )

  const { providerRiskHistory, currentProviderRisk, isLoading } = useProviderRiskSnapshot(provider.id)

  useRefetchProviderRiskOnRecalculation()

  return (
    <ThemeProvider theme={customBreakpointsTheme}>
      <Stack py={3} pr={3} spacing={2} sx={{ minWidth: (parentTheme.breakpoints.values.sm || 600) * 0.7 }}>
        <AutomatedRiskSection providerRisk={currentProviderRisk} isLoading={isLoading} />
        <RiskOverTimeSection providerRiskHistory={providerRiskHistory} isLoading={isLoading} />
      </Stack>
    </ThemeProvider>
  )
}

export default TopicalRiskCompanyPageScene
